module.exports = __webpack_public_path__ + "img/close.1cb04ef5.svg";